import {Injectable} from '@angular/core';
import {ConfigService} from '@services/infra/config.service';
import {Observable} from 'rxjs';
import {TrackingResource} from '@services/resource/tracking-resource';
import {timeout} from 'rxjs/operators';
import {ClientConfig} from '@app/client-config';
import {ErrorService} from '@services/error.service';
import {HttpIgnoringInterceptorsService} from '@services/http-ignoring-interceptors.service';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  constructor(
    private readonly errors: ErrorService,
    private readonly conf: ConfigService,
    private readonly http: HttpIgnoringInterceptorsService,
  ) {}

  public track(r: TrackingResource): Observable<void> {
    const url = `${this.conf.backendUrl}/v1/tracking`;
    return this.http.post<void>(url, r).pipe(timeout(ClientConfig.timeout), this.errors.withErrorHandler());
  }
}
